// Keeps every column readable before the table starts scrolling horizontally.
// Not an enumeration, so it does not go stale the next time one is added.
export const LOCATIONS_TABLE_MIN_WIDTH = 570;

// Wide enough for the user name plus one column per role without the roles
// grid scrolling sideways.
export const LOCATION_FORM_MODAL_WIDTH = 720;

// The user rights grid that follows the copy section has a sticky header at
// z-index 1, which otherwise paints straight through the open dropdown and
// makes the options behind it unclickable. Matches ColorSwatchPicker, the
// other floating layer in this same modal.
export const COPY_DROPDOWN_LIST_Z_INDEX = 50;

export const DELETE_LOCATION_MODAL_WIDTH = 480;

// Column widths for the fixed-size cells, leaving name to take the remainder.
export const LOCATION_COLUMN_WIDTHS = {
  color: 140,
  users: 120,
  actions: 100
} as const;

// qampo-ui-library's Checkbox puts its `id` on the wrapping label and looks it
// up with getElementById to tint the checkmark, so every instance on the page
// needs a unique id.
export const buildRoleCheckboxId = (userId: string, role: string): string =>
  `location-role-${userId}-${role}`;
